import React, { PropsWithChildren } from 'react'
import { Link, useParams } from 'react-router-dom'
import { generateAuditPermalink } from 'src/components/PageLayout/Permalink'
import { useHasGRCDashboards } from 'src/context/Gatekeeper'
import { DirectRoutes } from 'src/components/Reusable/RootPage/RootPage.constants'
import { GridRow } from 'src/components/Reusable/Grid'

type Props = PropsWithChildren<{
  isSelected?: boolean
  isClosed?: boolean
  auditId: string
}>

export function AuditRow(props: Props): JSX.Element {
  const id = `audit-index-item-${props.auditId}`
  const params = useParams()
  const pageContext = params.pageContext as string
  const hasGrcDashboards = useHasGRCDashboards()

  if (props.isClosed) {
    return (
      <GridRow selected={props.isSelected} id={id}>
        {props.children}
      </GridRow>
    )
  }

  return (
    <GridRow
      selected={props.isSelected}
      id={id}
      as={Link}
      to={generateAuditPermalink({
        pageContext,
        isInternalLink: true,
        overrideAuditId: props.auditId,
        destination: hasGrcDashboards
          ? DirectRoutes.GRC_DASHBOARDS
          : DirectRoutes.DASHBOARD,
      })}
    >
      {props.children}
    </GridRow>
  )
}
